import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  postMessage: null,
  postError: null,
  data: undefined,
  postData: {},
};

const postPAFormOneSlice = createSlice({
  name: "postPAFormOne",
  initialState,
  reducers: {
    postPAFormOneStart(state, payload) {
      state.loading = true;
      state.postError = null;
      state.postMessage = null;
    },

    postPAFormOneSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
      state.postMessage = action.payload.postMessage;
    },
    postPAFormOneDataSuccess(state, action) {
      state.postData = action.payload;
    },
    postPAFormOneFailure(state, action) {
      state.loading = false;
      state.postError = action.payload;
      state.postMessage = null;
    },
    clearData: (state) => {
      state.data = null;
    },
    clearMessage: (state) => {
      state.postError = null;
      state.postMessage = null;
    },
  },
});

export const {
  postPAFormOneStart,
  postPAFormOneSuccess,
  postPAFormOneDataSuccess,
  postPAFormOneFailure,
  clearData,
  clearError,
  clearMessage,
} = postPAFormOneSlice.actions;

export default postPAFormOneSlice.reducer;
